import {
  PAYTYPES_FETCHING,
  PAYTYPES_FAILED,
  PAYTYPES_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PAYTYPES_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PAYTYPES_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PAYTYPES_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
